import React from "react";
import { Particles } from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      options={{
        background: { color: { value: "#0d1117" } },
        particles: {
          number: { value: 100 },
          color: { value: "#8b5cf6" },
          opacity: { value: 0.4 },
          size: { value: 2 },
          move: { enable: true, speed: 0.3 },
        },
        interactivity: {
          events: { onHover: { enable: true, mode: "repulse" } },
          modes: { repulse: { distance: 70, duration: 0.4 } },
        },
      }}
    />
  );
}

export default Particle;
